export default "__VITE_ASSET__f6c9e7fb__"